import React from 'react';
import ToolLayout from '../components/ToolLayout';
import { DollarSign } from 'lucide-react';

/**
 * Standalone Financial & Insurance Summary tool.
 * Binder-safe summary (no account numbers); export to add to your binder.
 */
const FinancialSummaryTool = () => {
  return (
    <ToolLayout
      title="Financial & Insurance Summary"
      description="A safe-to-print overview of your emergency fund, insurance, and debts — no account numbers."
      icon={DollarSign}
      guide={{
        intro: 'Write down the basics of your finances so you can reach the right people after a disaster — no account numbers needed.',
        steps: [
          'Enter your emergency fund amount.',
          'List your insurance (type and company name).',
          'Add a summary of your debts.',
          'Save for your binder.',
        ],
      }}
    >
      <div className="max-w-2xl mx-auto space-y-6">
        <p className="text-muted-foreground">
          Write down the basics of your finances — just enough to contact your bank or insurance company after a disaster.
          No account numbers needed, just company names and policy types.
        </p>
        <p className="text-sm text-muted-foreground">
          Full financial summary form and Save coming soon. You can use the Budget tool for emergency fund details and save that for your binder.
        </p>
      </div>
    </ToolLayout>
  );
};

export default FinancialSummaryTool;
